module.exports = __webpack_public_path__ + "img/021783495894855ad8f78454eef31552c89ebf2f2559e7d2d47a0_0.a5336685.webp";